import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useSegment } from '../../../hooks/useSegment';
import SegmentResults from './segment-results';

const SegmentResultsView = () => {
  const { segmentId } = useParams<{ segmentId: string }>();
  const { segmentQuery } = useSegment(segmentId);

  const segmentResults = segmentQuery.data?.results;

  return <SegmentResults total={segmentResults?.totalCustomers || 0}
    included={segmentResults?.includedCustomers || 0}
    excluded={segmentResults?.excludedCustomers || 0}
    isLoading={segmentQuery.isFetching} />;
};

export default SegmentResultsView;
